import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import Autosuggest from "react-autosuggest";
import { useCookies } from "react-cookie";
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import Icon from "@iconify/react";

const PresupuestosConfiguracionEditModal = ({
    show,
    onHide,
    categoria,
    setCategoria,
    onSave
}) => {

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);    

    const handleChange = (field, value) => {
        setCategoria({ ...categoria, [field]: value });
    };

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }     

    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);    
    const [account, setAccount] = useState(0);
    const [name, setName] = useState("");    

    const [suggestions, setSuggestions] = useState([]);      

    const searchSuggestions = ( {value} ) => {
        setSuggestions(getSuggestions(value));
    }

    const clearSuggestions = () => {
        setSuggestions([]);
    }
    
    const onChangeName = (event, { newValue } ) => {
        setName(newValue);
    };

    const inputProps = {
        placeholder: "Escriba la cuenta",
        value: name,
        onChange: onChangeName,
        autocomplete: false
    };    

    const getSuggestions = value => {
        const inputValue = value.toLowerCase();
        return accounts.filter(lang =>
            (lang.descripcion.toLowerCase() + lang.codigo).includes(inputValue)
        );
    };     

    const getSuggestionValue = (suggestion) => {
        setAccount(suggestion.id);
        return suggestion.codigo + " - " + suggestion.descripcion;
    }    

    const renderSuggestion = (suggestion) => {
        return (
            <span>{suggestion.codigo + " - " + suggestion.descripcion}</span>
        );
    }    

    const retrieveAccountingAccounts = () => {
        setAccountsLoading(true);
        var currentFarm = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + "accountancy/accounts?id_estancia=" + currentFarm.id + "&tipo=P", prepareHeaders())
            .then(rs => {
                if (rs.status == 200) {
                    let { data } = rs.data;
                    setAccountsLoading(false);
                    setAccounts(data);
                    setAccount(0);
                }
                else {
                    setAccountsLoading(false);
                    setAccounts([]);
                    setAccount(0);
                }
            })
            .catch(error => {
                console.error(error);
                setAccountsLoading(false);
                setAccounts([]);
                setAccount(0);
            });        
    }      

    const searchAccount = (id) => {
        for(var i = 0; i < accounts.length; i++){
            if(parseInt(accounts[i].id) === parseInt(id)){
                return accounts[i];
            }
        }
        return {};
    }    
    
    const addDetail = (e) => {
        e.preventDefault();
        if(account != undefined && account != 0){
            let detail = searchAccount(account);
            setCategoria({ ...categoria, cuentas: [...categoria.cuentas, detail] });
            setAccount(0);
        }
    }    

    const removeFromDetails = (e, detail) => {
        e.preventDefault();
        var detailsNew = [];
        for(var i = 0; i < categoria.cuentas.length; i++){
            if(categoria.cuentas[i].id != detail.id){
                detailsNew.push(categoria.cuentas[i]);
            }
        }
        setCategoria({ ...categoria, cuentas: detailsNew });
    }    

    useEffect(() => {
        retrieveAccountingAccounts();
    }, []);    

    return categoria ? (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Editar categoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: "bold" }}>Categoría</Form.Label>
                        <Form.Control className="karanda-input"
                            type="text"
                            value={categoria?.categoria || ""}
                            onChange={(e) => handleChange("categoria", e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label style={{ fontWeight: "bold" }}>Tipo</Form.Label>
                        <Form.Control as ="select" className="karanda-input"
                            value={categoria?.tipoCategoriaPresupuesto || ""}
                            onChange={(e) => handleChange("tipoCategoriaPresupuesto", e.target.value)}
                        >
                            <option value="PRESUPUESTO">PRESUPUESTO</option>
                            <option value="INVERSION">INVERSION</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="cuenta">
                        <Form.Label style={{ fontWeight: "bold" }}>Cuenta contable</Form.Label>
                        <Row>
                            <Col>
                                <Autosuggest 
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={searchSuggestions}
                                    onSuggestionsClearRequested={clearSuggestions}
                                    getSuggestionValue={getSuggestionValue}
                                    renderSuggestion={renderSuggestion}
                                    inputProps={inputProps}
                                />                            
                            </Col>
                            <Col md="auto">
                                <Button size="sm" onClick={addDetail}>Agregar</Button>
                            </Col>
                        </Row>
                        <Row style={{padding: "20px"}}>
                            {
                                categoria.cuentas && categoria.cuentas.length > 0 ? (
                                    <Table style={{marginTop: ".5rem" }} className="karanda-table">
                                        <tbody>
                                            {
                                                categoria.cuentas.map((i) => (
                                                    <tr>
                                                        <td style={{ textAlign: "left" }}>{i.codigo + " - " + i.descripcion}</td>
                                                        <td>
                                                            <Icon tile="eliminar" icon={bxsTrash} style={{cursor: "pointer"}} width="15px" onClick={(e) => {removeFromDetails(e, i);}}/>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                )
                                : (<></>)
                            }
                        </Row>                                    
                    </Form.Group>                                          

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Guardar
                </Button>
            </Modal.Footer>
        </Modal>
    )
    : <></>;
};

export default PresupuestosConfiguracionEditModal;